import React from 'react'

export default function Footer() {
  return (
    <div className='container-fluid footer-main p-y-2 m-t-7'>
        <p>&copy; 2024 ROYAL RUSD, All rights reserved.</p>
    </div>
  )
}
